import cleanUpObject from './cleanUpObject';

export const updateSearchParamsAndUrl = ({ params }) => {
  const cleanParams = { ...params };
  cleanUpObject(cleanParams);
  const newURL = new URLSearchParams(cleanParams).toString();
  window.history.pushState({}, '', `?${newURL}`);
};
